export const LOGIN_ERROR_STORAGE_KEY = 'attendance.loginError';

/**
 * OAuth / login redirect の ?error= クエリを安全にデコードする
 * @param {string | null} raw
 * @returns {string | null}
 */
export function parseLoginErrorParam(raw) {
  if (!raw) {
    return null;
  }
  try {
    return decodeURIComponent(raw.replace(/\+/g, ' '));
  } catch {
    return raw;
  }
}

/**
 * @returns {string | null}
 */
export function readLoginErrorFromWindow() {
  if (typeof window === 'undefined') {
    return null;
  }
  const params = new URLSearchParams(window.location.search);
  return parseLoginErrorParam(params.get('error'));
}
